import React from 'react';
import { VideoPlayerStyled } from './video-player.styled';
import ReactPlayer from 'react-player';

const VideoPlayer = () => {
  return (
    <VideoPlayerStyled.Container>
      <ReactPlayer
        url={'/assets/AllianzCoworking.mp4'}
        controls={true}
        width="900px"
        height="100%"
      />
    </VideoPlayerStyled.Container>
  );
};

export default VideoPlayer;
